import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";

const TermsOfUsePage = () => (
  <LegalDocumentPage id="terms-of-use" labelKey="Terms of Use" contentKey="termsOfUse" path="/terms-of-use" />
);

export default TermsOfUsePage;
